import { dateKeyAliases, geoKeyAliasMap, textKeyAliasMap } from "./ast-aliases.js";
const dateKeys = [
  ...Object.values(dateKeyAliases)
];
const numericKeys = [
  ...dateKeys,
  ...Object.values(geoKeyAliasMap),
  "filesize",
  "height",
  "width",
  "ratio",
  "duration",
  "iso"
];
const rangeKeys = [
  ...numericKeys,
  "date"
];
const textKeys = [
  ...Object.values(textKeyAliasMap),
  "id",
  "type",
  "index",
  "file",
  "filename",
  "path",
  "ext",
  "model",
  "make",
  "description",
  "country",
  "state",
  "city",
  "tag",
  "object"
];
export {
  dateKeys,
  numericKeys,
  rangeKeys,
  textKeys
};
//# sourceMappingURL=ast-keys.js.map
